import React, { useEffect } from 'react';

import cx from 'classnames';

import { useGGTheme } from 'hooks/theme/useGGTheme';
import { useScreenSize } from 'hooks/utils/useScreenSize';

import s from './Marquee.module.css';

interface MarqueeProps {
  items: string[];
}

const Marquee = ({ items }: MarqueeProps) => {
  const MIN_SPEED = 20;
  const ref = React.useRef<HTMLUListElement>(null);
  const [isContentSmallerThanScreen, setIsContentSmallerThanScreen] =
    React.useState(false);
  const { width: screenWidth = 0 } = useScreenSize();
  const { theme } = useGGTheme();

  const currentPalette =
    theme && theme.palette.name ? theme.palette.name.toLowerCase() : null;

  const contentWidth = ref?.current?.offsetWidth || 0;
  const totalChars =
    items && items.length > 0
      ? items.reduce((acc, item) => {
          const itemLength = item ? item.length : 0;

          return acc + itemLength + 3;
        }, 0)
      : 0;

  const animationDuration =
    totalChars / 2 < MIN_SPEED ? MIN_SPEED : totalChars / 2;

  useEffect(() => {
    setIsContentSmallerThanScreen(contentWidth < screenWidth);
  }, [contentWidth, screenWidth]);

  if (items.length === 0) {
    return null;
  }

  return (
    <div className={cx(s.root, currentPalette && s[currentPalette])}>
      <div
        className={cx(
          s.container,
          {
            [s.marquee]: isContentSmallerThanScreen,
            [s.halfMarquee]: !isContentSmallerThanScreen,
          },
          currentPalette && s[currentPalette],
        )}
        style={{
          animationDuration: `${animationDuration}s`,
        }}
      >
        <ul ref={ref}>
          {items &&
            items.map((item) => (
              <li key={item}>
                <p> • </p>
                <p>{item?.toUpperCase()}</p>
              </li>
            ))}
        </ul>
        <ul aria-hidden="true">
          {items &&
            items.map((item) => (
              <li key={item}>
                <p> • </p>
                <p>{item?.toUpperCase()}</p>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export { Marquee };
